import dayjs, { Dayjs } from 'dayjs'
import { DatePickerDateValue } from './DateRangePicker.types'

/**
 * This function calculates the start date of the calendar grid for a given month.
 * The calendar grid typically starts on the first day of the week as per locale settings,
 * @param month - Any day in the month
 * @returns start of the calendar grid (may be in previous month)
 */
function startOfCalendar(month: Dayjs) {
  // Calendar grid starts on locale week start
  const firstOfMonth = month.startOf('month')
  const weekday = firstOfMonth.day() // 0..6, 0 Sunday (Day of week)
  const weekStart = dayjs().localeData().firstDayOfWeek()
  const diff = (weekday - weekStart + 7) % 7

  return firstOfMonth.subtract(diff, 'day')
}

/**
 * This function builds an array of days to display in a calendar grid for a given month.
 * The grid typically shows 6 weeks (42 days) to cover all possible month layouts.
 * @param month - Any day in the month
 * @returns days to display in the calendar grid (6 weeks, 42 days)
 */
export function buildCalendarDays(month: Dayjs) {
  const start = startOfCalendar(month)
  const days: Dayjs[] = []
  for (let i = 0; i < 42; i += 1) {
    days.push(start.add(i, 'day'))
  }
  return days
}

export function isDateInRange(date: Dayjs, start: DatePickerDateValue, end: DatePickerDateValue) {
  if (!start || !end) return false
  return date.isBetween(start, end, 'day', '[]')
}

export function isDateInHover(date: Dayjs, start: DatePickerDateValue, hover: DatePickerDateValue) {
  if (!start || !hover) return false
  return date.isBetween(start, hover, 'day', '[]')
}
